module.exports = __webpack_public_path__ + "fonts/ufonts.com_klavika-mediumitalic-opentype.50d6d04e.otf";